import KendoDropDownListMixin from './KendoDropDownListMixin'

export default {
    name: 'kendo-dropdownlist',
    mixins: [ KendoDropDownListMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/index.js